<script>
import { defineComponent } from "vue";

const name = 'PdfSlot'

const pdfConfig =  {
					margin:       [20, 15, 20, 15],
					filename:     'exaple.pdf',
					image:        { type: 'jpeg',quality: 0.98 },
					html2canvas:  { scale: 2, logging: true, dpi: 2400, letterRendering: true },
					jsPDF:        { unit: 'mm', format: 'a4', orientation: 'p' },
					pagebreak: { after: '.page-break-after', avoid: ['li','p','ul','ol','tr','section','.avoid-page-break-before'], }
				}




const pdf = {
	mounted(el,pdfCallback) {
		pdfCallback.value(el,pdfConfig)
	}
}

export default defineComponent({
  name,

  components: { }, 

  props: {
	isDev: {	
			type: Boolean,
			default: false 
		},

	pdfCallback: {
		type: Function,
		default: () => {}
	}	
},
  
	directives:{
		pdf
	},

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { }, 

});
</script>

<template>
	<div >
		<Teleport v-if="isDev" to=".popup-slot">
			<div class="dev" >
				<slot></slot>
			</div>
		</Teleport>
		<div v-else v-show="false">
			<div  v-pdf="pdfCallback" class="pdf">
				<slot></slot>
			</div>
		</div>

	</div>
</template>


<style scoped>
.pdf{
	width: 100%;
	height: 100%;
}

.dev{
	position: absolute;
	z-index: 1000;
	width: 820px;
	height: 100%;	
	padding: 4rem;
	background-color: white;  
	overflow: auto;

}
</style>
